import { render, staticRenderFns } from "./FailedOrder.vue?vue&type=template&id=4b60a2b8&"
import script from "./FailedOrder.vue?vue&type=script&lang=js&"
export * from "./FailedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports